/* tslint:disable */
/* eslint-disable */
export enum ProduktEnum {
  Gas = 'Gas',
  Olie = 'Olie',
  Varmepumpe = 'Varmepumpe'
}
